import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Row, Button, Badge } from 'reactstrap';
import ReactTable from 'react-table';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import DataTablePagination from '../../../../components/DatatablePagination';
import { Card, CardBody, CardTitle } from 'reactstrap';
import IntlMessages from '../../../../helpers/IntlMessages';
import {
    reactSelectOptionDiffrentPro
} from '../../../../helpers/Utils';
import {
    gAPI_MissedResponseList,
    postAPI_TrackEvent, gAPI_Users_By_Id
} from '../../../../constants/APIs';
import { AxiosAPI, getGroupID, getUserID } from '../../../../helpers/AxiosAPI';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UpdateStatus from './Components/UpdateStatus';
import ConversationPopup from './Components/ConversationPopup';
import FAQForm from '../FAQ/Components/FAQForm';
import Validation from '../../../../components/Validation';
import {
    API_FAQ,
} from '../../../../constants/APIs';
import { CSVLink } from 'react-csv';

const statusList = [
    { label: "Open", value: "Open" },
    { label: "Resolved", value: "Updated" },
    { label: "Ignored", value: "Ignored" },
];

const csvHeaders = [
    { label: "Missed Question", key: "missedQuestion" },
    { label: "Conversation Summary", key: "responseGiven" },
    { label: "Status", key: "currentStatus" },
    { label: "Created Date", key: "createdDate" },
    { label: "Status Updated By", key: "statusUpdatedBy" },
    { label: "Status Update Time", key: "statusUpdateUtc" },
];

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            isLoading: true,
            isFiltering: false,
            selectedStatus: [{ label: "Open", value: "Open" }],
            filteredData: [],
            startDate: moment().subtract(29, 'days'),
            endDate: moment(),
            statusFilter: [],
            createFaq: false,
            faqCollectionList: [],
            msg: [],
            open: false,
            selectedMissedQuestion: '',
            csvData: [],
        };
    }
    handleToggle = (missedQuestion = '') => {
        this.setState((prevState) => ({
            createFaq: !prevState.createFaq,
            selectedMissedQuestion: missedQuestion,
        }));
    };
    getDataTableColumns = () => [
        {
            Header: <IntlMessages id='feedback.missed-question' />,
            accessor: 'missedQuestion',
            className: 'col-missed-question',
            Cell: (props) => <p className="wrap-pragraaph">{props.value}</p>,
        },
        // {
        //     Header: 'Question',
        //     accessor: 'questionAsked',
        //     Cell: (props) => <p className="">{props.value}</p>,
        // },
        {
            Header: <IntlMessages id='feedback.conversation-summary' />,
            accessor: 'responseGiven',
            className: 'col-convo',
            Cell: (props) => {
                const conversationId = props.row._original ? props.row._original.conversationId : null;
                console.log('convoo', conversationId, props.row)
                return (
                    <div className='flex-tab flex-row'>
                        <p className="wrap-pragraaph">{props.value}</p>
                        <div className="ml-2 convo" >
                            <ConversationPopup conversationid={conversationId}></ConversationPopup>
                        </div >
                    </div>
                );
            }
            // <div>
            //     <p className="wrap-pragraaph">{props.row.original.conversationId}</p>
            // </div>,
        },
        {
            Header: <IntlMessages id='content.timestamp' />,
            accessor: 'createdDate',
            className: 'col-timestamp',
            Cell: (props) => <p className="" >
                <span >{moment(props.value).format('ddd, MMM DD YYYY')}</span><br />
                <span className="">{moment(props.value).format('hh:mm a')}</span>
            </p>,
        },
        {
            Header: <IntlMessages id='pages.status' />,
            accessor: 'currentStatus',
            className: 'col-status',
            Cell: (props) => (
                <div className="flex-tab flex-row">
                    <div className="mr-0">
                        <Badge color="warning">
                            {props.value === "Ignored" ? "Ignored" : props.value === "Updated" ? 'Resolved' : props.value}</Badge>
                        {props.value !== "Open" &&
                            <span className="font-sx" ><br />{props.original.statusUpdatedBy} On <br />
                                {moment(props.original.statusUpdateUtc).format(
                                    'MMM DD YYYY hh:mm a'
                                )}</span>}
                    </div>
                    <div className="mr-0">
                        {props.value !== "Open" ?
                            <UpdateStatus id={props.original.id} value={"Open"}></UpdateStatus> : ""}
                        {props.value !== "Updated" && props.value !== "Ignored" ?
                            <UpdateStatus id={props.original.id} value={"Updated"}></UpdateStatus> : ""}
                        {props.value !== "Ignored" && <UpdateStatus id={props.original.id} value={"Ignored"}></UpdateStatus>}
                    </div>

                    <div className="mr-4">
                        <Button
                            size="xs"
                            outline
                            className="ml-2 btn-round btn-out"
                            color='primary'
                            onClick={() => this.handleToggle(props.original.missedQuestion)}

                        >
                            {' '}
                            + <IntlMessages id='dashboards.add-faq' />
                        </Button>
                    </div>
                </div>)
        },
    ];

    componentDidMount() {
        var filterStatusList = [];
        statusList.map((l) => filterStatusList.push({ ...l, checked: false }));
        this.setState({ statusFilter: filterStatusList });

        if (this.props.email !== '') {
            AxiosAPI({
                method: 'post',
                url: `${postAPI_TrackEvent}`,
                data: {
                    eventName: 'Dashboard Users and Admin',
                    email: this.props.email,
                },
            }).then(
                (res) => { },
                (error) => {
                    console.log(error);
                }
            );
        }
        this.LoadData("Open", this.state.startDate, this.state.endDate);
    }

    LoadData = (status, startdate, enddate) => {
        const start = moment(startdate).format('YYYY-MM-DD') + ' 00:00:00';
        const end = moment(enddate).format('YYYY-MM-DD') + ' 23:59:59';
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_MissedResponseList}?groupId=${getGroupID()}&propertyId=${this.props.propertyId}&dateFrom=${start}&dateTo=${end}&status=${status}`,
        }).then(
            (res) => {
                this.setState((state) => ({
                    data: res.data,
                    csvData: res.data,
                    isLoading: false,
                }));
            },
            (error) => {
                this.setState({ loading: false, error, isLoading: false });
            }
        );
    }
    handleChangeDate = (date) => {
        this.setState({
            startDate: date,
        });
    };

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        });
    };
    handleChangeSelect = (value, { name }) => {
        if (name === "status") {
            var m = this.state.statusFilter.map((elem) => {
                value.map((sel) => {
                    if (sel.value.toLowerCase() === elem.value.toLowerCase()) {
                        elem.checked = true;
                    }
                });
                return elem;
            });
            this.setState({
                selectedStatus: value,
                statusFilter: m,
            });
        }
    }
    handleSubmitClick = () => {
        this.setState({ isLoading: true });
        this.LoadData(this.state.selectedStatus.length > 0 ? this.state.selectedStatus.map((a) => a.value).join('|') : '-1', this.state.startDate, this.state.endDate);
        this.setState((state) => ({
            isFiltering: false,
        }));
    }
    handleAddFAQ = (inputData) => {
        AxiosAPI({
            method: 'post',
            url: API_FAQ,
            data: inputData,
        }).then((res) => {
            if (
                res.data.HttpStatusCode !== undefined &&
                res.data.HttpStatusCode === 400 &&
                res.data.Messages !== undefined &&
                res.data.Messages !== null &&
                res.data.Messages.length > 0
            ) {
                this.setState({ msg: res.data.Messages });
                this.setState({ open: true });
            } else {
                this.LoadData("Open", this.state.startDate, this.state.endDate);
                this.handleToggle();
            }
        });
    };

    render() {
        const { startDate, endDate } = this.state;
        return (
            <Fragment>
                <div className="mb-4">
                    <h4><b><IntlMessages id='dashboards.enhanceKnowledge' /></b></h4>
                    <p >  <IntlMessages id='dashboards.reviewUnanswered' /></p>
                </div>
                <div className="mb-2 ml-2">
                    <Row>
                        <div className=" d-inline-block  mt-2">
                            <Button
                                size="xs"
                                color="primary"
                                className=""
                                onClick={() => this.setState({ isFiltering: !this.state.isFiltering })}
                            >
                                <div className='d-flex'>
                                    <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />
                                    <IntlMessages id="menu.show-filter" />
                                    <div className='ml-1' style={{ marginTop: "2px" }}>
                                        {this.state.isFiltering ?
                                            <i className='simple-icon-arrow-up p-1'></i> :
                                            <i className='simple-icon-arrow-down p-1'></i>
                                        }
                                    </div>
                                </div>
                            </Button>
                        </div>
                        <div className=" d-inline-block  mt-2 mr-2">
                            <CSVLink
                                data={this.state.csvData}
                                headers={csvHeaders}
                                filename={`MissedResponses_${moment().format('YYYYMMDD_HHmmss')}.csv`}
                            >
                                <Button
                                    size="xs"
                                    outline
                                    className="ml-2 btn-round btn-outline-primary"
                                    color='primary'
                                >   <IntlMessages id='dashboards.download' /> CSV </Button>
                            </CSVLink>
                        </div>
                        {this.props.locale && this.props.locale === 'en' && <a href="/app/pages/propinfo/publish-ai">
                            <Button
                                color="primary"
                                outline
                                className='mt-2 ml-2'
                                size="xs"
                            >
                                Publish AI
                            </Button>
                        </a>
                        }
                    </Row>
                </div>
                <Colxx xxs="12" className="mb-2 text-right">
                    <strong><hr /></strong>
                </Colxx>
                {this.state.isFiltering && (
                    <Card className="filter-width mt-2" style={{ position: "absolute", zIndex: "1", top: "7rem", marginLeft: "0rem", boxShadow: "0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)" }}>
                        <CardBody >

                            <Colxx md="12" >
                                <Row>
                                    <Colxx xxs="12" md="12" className="mb-2">
                                        <DatePicker
                                            selected={startDate ? new Date(startDate) : null} // ensure Date object
                                            onChange={this.handleChangeDate}
                                            placeholderText="Start Date"
                                            dateFormat="dd/MM/yyyy"
                                        />
                                    </Colxx>
                                    <Colxx xxs="12" md="12" className="mb-2">
                                        <DatePicker
                                            selected={endDate ? new Date(endDate) : null}
                                            onChange={this.handleChangeEndDate}
                                            placeholderText="End Date"
                                            dateFormat="dd/MM/yyyy"
                                        />
                                    </Colxx>
                                    <Colxx xxs="12" md="12" className=" mb-2">
                                        <Select
                                            isMulti={true}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            name="status"
                                            placeholder="Status"
                                            onChange={this.handleChangeSelect}
                                            options={
                                                statusList
                                                    ? reactSelectOptionDiffrentPro(
                                                        statusList,
                                                        true,
                                                        'value',
                                                        'label',
                                                        'Select Status'
                                                    )
                                                    : []
                                            }
                                            value={this.state.selectedStatus}
                                        />
                                    </Colxx>
                                    <Colxx xxs="12" md="12" >
                                        <Button size={"xs"}
                                            color="primary"
                                            className="mb-2 mt-2"
                                            onClick={() => this.handleSubmitClick()}>
                                            Search
                                        </Button>
                                        <Button
                                            size="xs"
                                            color="secondary"
                                            className="mb-2 ml-2 mt-2"
                                            onClick={() => this.setState({ isFiltering: false })}
                                        >
                                            <IntlMessages id='pages.cancel' />
                                        </Button>

                                    </Colxx>
                                </Row>
                            </Colxx>
                        </CardBody>
                    </Card>
                )}
                <div className="mb-2">
                    <Fragment>

                        <Card className="mb-2">
                            <CardBody>
                                {!this.state.isLoading && this.state.data ? (
                                    <ReactTable
                                        data={Array.isArray(this.state.data) ? this.state.data : []}
                                        columns={this.getDataTableColumns()}
                                        defaultPageSize={this.state.itemsPerPage}
                                        filterable={false}
                                        showPageJump={true}
                                        PaginationComponent={DataTablePagination}
                                        showPageSizeOptions={true}
                                        defaultSorted={[
                                            {
                                                id: 'createdDate',
                                                desc: true,
                                            },
                                        ]}
                                    />
                                ) : (
                                    <div className="loading" />
                                )}
                            </CardBody>
                        </Card>
                    </Fragment>
                </div>
                {this.state.createFaq && (
                    <FAQForm
                        faqCollectionList={this.state.faqCollectionList}
                        label={'Create FAQ'}
                        toggle={this.handleToggle}
                        submit={this.handleAddFAQ}
                        visible={this.state.createFaq}
                        missedQuestion={this.state.selectedMissedQuestion}
                    ></FAQForm>

                )}
                <Validation
                    open={this.state.open}
                    messages={this.state.msg}
                    toggle={() => {
                        this.setState({ open: true })
                    }}
                ></Validation>
            </Fragment>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, email, locale } = settings;
    return {
        propertyId,
        email,
        locale
    };
};
export default injectIntl(
    connect(mapStateToProps, {})(Index)
);
